/* eslint-disable */

function setupCustomSettings(
    modifyEmbeddedSvcCallback,
    finishedLoadingCallback,
    onWebchatOpenCallback,
    onWebchatCloseCallback
) {
    modifyEmbeddedSvcCallback();
    embedded_svc.addEventHandler("onSettingsCallCompleted", finishedLoadingCallback);
    embedded_svc.addEventHandler("afterMaximize", onWebchatOpenCallback);
    embedded_svc.addEventHandler("afterDestroy", onWebchatCloseCallback);
}

/*
The code below is generated from salesforce but modified in the following ways:
  * Only the javascript inside the second <script> tag in the provided salesforce code is copy pasted
  * CSS is not copied in
  * First <script> tag loading in the file from the CDN is not copied in
  * Copy the entire contents of the second <script> tag inside the initializeSalesforceWebchatForQa
      method and add a call to setupCustomSettings before the 'embedded_svc.init()' method is called
      
      Actual call to paste in:
      setupCustomSettings(
            modifyEmbeddedSvcCallback,
            finishedLoadingCallback,
            onWebchatOpenCallback,
            onWebchatCloseCallback
        );
*/

export function initializeSalesforceWebchatForQa(
    modifyEmbeddedSvcCallback,
    finishedLoadingCallback,
    onWebchatOpenCallback,
    onWebchatCloseCallback
) {
    var initESW = function (gslbBaseURL) {
        embedded_svc.settings.displayHelpButton = true; //Or false
        embedded_svc.settings.language = ""; //For example, enter 'en' or 'en-US'

        //embedded_svc.settings.defaultMinimizedText = '...'; //(Defaults to Chat with an Expert)
        //embedded_svc.settings.disabledMinimizedText = '...'; //(Defaults to Agent Offline)

        //embedded_svc.settings.loadingText = ''; //(Defaults to Loading)
        //embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

        // Settings for Chat
        //embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
        // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
        // Returns a valid button ID.
        //};
        //embedded_svc.settings.prepopulatedPrechatFields = {}; //Sets the auto-population of pre-chat form fields
        //embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
        //embedded_svc.settings.offlineSupportMinimizedText = '...'; //(Defaults to Contact Us)

        embedded_svc.settings.enabledFeatures = ["LiveAgent"];
        embedded_svc.settings.entryFeature = "LiveAgent";

        setupCustomSettings(
            modifyEmbeddedSvcCallback,
            finishedLoadingCallback,
            onWebchatOpenCallback,
            onWebchatCloseCallback
        );

        embedded_svc.init(
            "https://safelite2--safeliteua.sandbox.my.salesforce.com",
            "https://safelite2--safeliteua.sandbox.my.salesforce-sites.com/chat",
            gslbBaseURL,
            "00DDJ000000HRqO",
            "Sales_Central_Snap_in",
            {
                baseLiveAgentContentURL:
                    "https://c.la12s-core1.sfdc-8tgtt5.salesforceliveagent.com/content",
                deploymentId: "572DJ00000001j3",
                buttonId: "573DJ00000001ur",
                baseLiveAgentURL: "https://d.la12s-core1.sfdc-8tgtt5.salesforceliveagent.com/chat",
                eswLiveAgentDevName:
                    "EmbeddedServiceLiveAgent_Parent04IDJ0000008OZk2AM_1883057c9a6",
                isOfflineSupportEnabled: false,
            }
        );
    };

    if (!window.embedded_svc) {
        var s = document.createElement("script");
        s.setAttribute(
            "src",
            "https://safelite2--safeliteua.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js"
        );
        s.onload = function () {
            initESW(null);
        };
        document.body.appendChild(s);
    } else {
        initESW("https://service.force.com");
    }
}
